// DTM
import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";

import scale from "../helper/scaling";

import text from "../helper/text";
import Logo from "./Logo";

const Wrapper = styled.div`
  width: 100%;
  float: left;
`;
const Inner = styled.div`
  margin: 25px 25px 0 25px;
  width: calc(100% - 50px);
  float: left;

  @media (min-width: 1400px) {
    width: 1350px;
    margin: 25px calc(50% - 675px) 0 calc(50% - 675px);
  }
  @media (max-width: 700px) {
    width: 100%;
    margin: 0;
  }
`;
const Top = styled.div`
  width: 1040px;
  padding: 30px calc(50% - 520px) 30px calc(50% - 520px);
  color: white;
  font-size: 12px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 15px;
  letter-spacing: 0.8px;
  color: rgba(255, 255, 255, 0.8);
  background-color: #3949ab;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 1150px) {
    width: calc(100% - 50px);
    padding: 25px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding-left: 23px;
    padding-right: 23px;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.7px;
  }
`;

const LogoContainer = styled.div`
  height: 26px;
  width: 181px;
  margin-right: 2rem;

  @media (max-width: 700px) {
    margin-right: 0;
    margin-bottom: 1rem;
  }
`;

const Middle = styled.div`
  width: 1040px;
  padding: 49px calc(50% - 520px) 44px calc(50% - 520px);

  height: auto;
  background-color: #f9f9f9;
  float: left;
  position: relative;

  display: flex;
  @media (max-width: 1150px) {
    width: calc(100% - 50px);
    padding: 49px 25px 44px 25px;
  }
  @media (max-width: 1100px) {
    width: calc(100% - 50px);
    padding: 47px 25px 33px 25px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 55px 23px 18px 23px;
    display: block;
  }
`;
const Stack = styled.div`
  margin-left: 94px;
  max-width: 310px;
  flex-shrink: 1;
  :first-child {
    margin: 0;
  }
  @media (max-width: 1100px) {
    margin-left: ${scale(1100, 767, 94, 64, "vw")};
    max-width: ${scale(1100, 700, 310, 195, "vw")};
    :first-child {
      margin: 0;
    }
    :last-of-type {
      margin-right: 60px;
    }
  }
  @media (max-width: 700px) {
    width: 0;
    height: 0;
    overflow: hidden;
    display: none;
    margin: 0;
    :first-of-type {
      width: 100%;
      height: auto;
      display: block;
      max-width: none;
    }
  }
`;
const Title = styled.div`
  font-family: Lato;
  font-size: 16px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.44;
  letter-spacing: 1px;
  color: #3949ab;

  margin-bottom: 24px;

  @media (max-width: 1100px) {
    font-size: ${scale(1100, 700, 16, 14, "vw")};
    line-height: ${scale(1100, 700, 16 * 1.44, 13 * 1.77, "vw")};
    letter-spacing: ${scale(1100, 767, 1, 0.8, "vw")};

    margin-bottom: ${scale(1100, 767, 24, 20, "vw")};
  }
  @media (max-width: 700px) {
    font-size: 13px;
    line-height: 1.38;
    letter-spacing: 0.7px;
    text-align: center;

    margin-bottom: 20px;
  }
`;
const Body = styled.div`
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.08;
  letter-spacing: 0.7px;
  color: #000000;

  @media (max-width: 1100px) {
    font-size: 13px;
    line-height: 1.62;
    letter-spacing: 0.8;
  }
  @media (max-width: 700px) {
    font-size: 11px;
    line-height: 1.64;
    letter-spacing: 0.6px;
    text-align: center;
  }
`;
const PlainLink = styled.a`
  color: inherit;
  text-decoration: inherit;
`;
const MenuLink = PlainLink.extend`
  clear: both;
  float: left;
`;
const Tmv = styled.img`
  position: absolute;
  right: calc(50% - 520px);
  bottom: 44px;
  width: 93px;
  height: 55px;

  @media (max-width: 1150px) {
    right: 25px;
  }
  @media (max-width: 1100px) {
    width: 74px;
    height: 44px;
    right: 11px;
    bottom: 15px;
  }
  @media (max-width: 700px) {
    position: relative;
    bottom: 0;
    right: 0;
    margin: 22px calc(50% - 37px) 0 calc(50% - 37px);
  }
`;

const Bottom = styled.div`
  width: 1040px;
  padding: 0 calc(50% - 520px);

  height: 59px;
  float: left;
  @media (max-width: 1150px) {
    width: calc(100% - 50px);
    padding: 0 25px 0 25px;
  }
  @media (max-width: 1100px) {
    height: 56px;
  }
  @media (max-width: 700px) {
    padding: 5px 0 10px 0;
    width: 100%;
    height: auto;
  }
`;
const LeftLinks = styled.div`
  height: 23px;
  padding: 17px 0 19px 0;
  margin: 0;
  float: left;

  display: flex;

  @media (max-width: 1100px) {
    padding: 15px 0 18px 0;
  }
  @media (max-width: 700px) {
    width: calc(100% - 24px);
    margin: 0 12px;
    padding: 0;
    height: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
const LeftLink = styled.div`
  height: 23px;
  font-family: Lato;
  font-size: 14px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #3949ab;

  margin-left: 35px;
  :first-child {
    margin-left: 0;
  }

  @media (max-width: 1100px) {
    font-size: 13px;
    line-height: 1.77;

    margin-left: 22px;
    :first-child {
      margin-left: 0;
    }
  }
  @media (max-width: 700px) {
    margin: 0 11px;
    height: auto;

    :first-child {
      margin-left: 11px;
    }
  }
`;
const RightLinks = styled.div`
  height: 23px;
  padding: 17px 0 19px 0;
  margin: 0;
  float: right;

  display: flex;

  @media (max-width: 1100px) {
    padding: 17px 0 16px 0;
  }
  @media (max-width: 700px) {
    width: calc(100% - 32px);
    margin: 6px 16px 0 16px;
    padding: 0;
    height: auto;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
`;
const RightLink = styled.div`
  height: 23px;
  opacity: 0.6;
  font-family: Lato;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.85);

  margin-left: 15px;
  :first-child {
    margin-left: 0;
  }
  @media (max-width: 1100px) {
    font-size: 12px;
    line-height: 1.92;

    margin-left: 12px;
    :first-child {
      margin-left: 0;
    }
  }
  @media (max-width: 700px) {
    margin: 0 7px;
    height: auto;

    height: 11px;
    font-size: 9px;
    line-height: 11px;
    text-align: center;

    :first-child {
      margin-left: 7px;
    }
  }
`;
const BottomLine = styled.div`
  width: 100%;
  height: 39px;
  border-top: solid 1px #e5e5e5;
  line-height: 39px;

  font-family: Lato;
  font-size: 10px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: rgba(0, 0, 0, 0.5);
  float: left;

  @media (max-width: 1100px) {
    height: 36px;
    line-height: 36px;
  }
  @media (max-width: 700px) {
    width: calc(100% - 46px);
    padding: 8px 23px 15px 23px;
    height: auto;

    line-height: 12px;
  }
`;

class Footer extends Component {
  render() {
    let serviceMenu = [];
    let aboutMenu = [];
    let contactItem = [];
    let faqItem = [];
    let privacyItem = [];
    let termsItem = [];
    let linkItems = [];
    if (this.props.contentMenu && this.props.contentMenu.menu) {
      serviceMenu = this.props.contentMenu.menu.find(
        i => i.short === "services"
      );
      aboutMenu = this.props.contentMenu.menu.find(i => i.short === "about-us");
      contactItem = aboutMenu.children.find(
        i => i.short === "contact-and-opening-hours"
      );
      faqItem = aboutMenu.children.find(i => i.short === "faq");
      privacyItem = aboutMenu.children.find(i => i.short === "privacy-cookies");
      termsItem = aboutMenu.children.find(
        i => i.short === "terms-and-conditions"
      );
      linkItems = aboutMenu.children.filter(
        item =>
          item.type === "component" &&
          item !== contactItem &&
          item !== faqItem &&
          item !== privacyItem &&
          item !== termsItem
      );
    }

    return (
      <Wrapper>
        <Inner>
          <Top>
            <LogoContainer>
              <Logo white />
            </LogoContainer>
            {text.get(this.props.translations, "Sub_heading")}
          </Top>
          <Middle>
            <Stack>
              <Title>Van Zadelhoff Veilingen & Taxaties</Title>
              <Body>
                Nieuwe Havenweg 53A<br />
                1216 BL Hilversum<br />
                Nederland<br />
                &nbsp;<br />
                (+31) 035 - 624 7170<br />
                <PlainLink href="mailto:info@vanzadelhoff.nl">
                  INFO@VANZADELHOFF.NL
                </PlainLink>
              </Body>
            </Stack>
            <Stack>
              <Title>{serviceMenu.title}</Title>
              <Body>
                {serviceMenu.children && serviceMenu.children.length > 0
                  ? serviceMenu.children.map(item => (
                      <MenuLink key={item.short} href={item.short}>
                        {item.title}
                      </MenuLink>
                    ))
                  : []}
              </Body>
            </Stack>
            <Stack>
              <Title>{aboutMenu.title}</Title>
              <Body>
                {linkItems.map(item => (
                  <MenuLink key={item.short} href={item.short}>
                    {item.title}
                  </MenuLink>
                ))}
              </Body>
            </Stack>
            <Tmv src="data:image/png;base64,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" />
          </Middle>
          <Bottom>
            <LeftLinks>
              <LeftLink>
                <PlainLink href={contactItem.short}>
                  {contactItem.title}
                </PlainLink>
              </LeftLink>
              <LeftLink>
                <PlainLink href={faqItem.short}>{faqItem.title}</PlainLink>
              </LeftLink>
            </LeftLinks>
            <RightLinks>
              <RightLink>
                <PlainLink href={privacyItem.short}>
                  {privacyItem.title}
                </PlainLink>
              </RightLink>
              <RightLink>
                <PlainLink href={termsItem.short}>{termsItem.title}</PlainLink>
              </RightLink>
            </RightLinks>
          </Bottom>
        </Inner>
        <BottomLine>
          www.vanzadelhoff.nl | Van Zadelhoff Veilingen & Taxaties | All rights
          reserved
        </BottomLine>
      </Wrapper>
    );
  }
}

const mapStateToProps = state => {
  return {
    contentMenu: state.contentMenu.data,
    translations: state.translations.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onTodoClick: id => {
      dispatch({ type: "NONE" });
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js